import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/projects/amazighgroupe/app/[locale]/home_page.tsx");
